import { Injectable } from '@angular/core';
import { Pmc } from '../../../data-model/idb/pmc';
import { TpubDbService } from './tpub-db.service';
import { pmcStoreName } from '../../../constants/indexed-store-config';
import { Observable, Observer } from 'rxjs';
import { Dexie } from 'dexie';

@Injectable({
  providedIn: 'root'
})
export class PmcService {
  public table: Dexie.Table<Pmc>;

  constructor(private tpubDbService: TpubDbService) {
    this.table = this.tpubDbService.table(pmcStoreName);
  }

  add(data: Pmc): Observable<boolean> {
    return new Observable((observer: Observer<boolean>) => {
      this.table.add(data).then(result => {
        observer.next(true);
        observer.complete();
      }, (error) => {
        observer.error(error);
      });
    });
  }

  addBulk(data: Pmc[]): Observable<boolean> {
    return new Observable((observer: Observer<boolean>) => {
      if (data && data.length > 0) {
        this.table.bulkAdd(data).then((result) => {
          observer.next(true);
          observer.complete();
        }, (error) => {
          observer.error(error);
        });
      } else {
        observer.next(true);
        observer.complete();
      }
    });
  }

  clear(): Observable<boolean> {
    return new Observable((observer: Observer<boolean>) => {
      this.table.clear().then(() => {
        observer.next(true);
        observer.complete();
      }, (err) => {
        observer.error(err);
      });
    });
  }
  getByPmcCode(pmc: string): Observable<Pmc> {
    return new Observable((observer: Observer<Pmc>) => {
      this.table.get({ pubCode: pmc }).then((data: Pmc) => {
        observer.next(data);
        observer.complete();
      }, (error) => {
        observer.error(error);
      });
    });
  }

  getAll(): Observable<Pmc[]> {
    return new Observable((observer: Observer<Pmc[]>) => {
      this.table.toArray().then((data: Pmc[]) => {
        observer.next(data);
        observer.complete();
      }, (error) => {
        observer.error(error);
      });
    });
  }

  remove(id: number): Observable<boolean> {
    return new Observable((observer: Observer<boolean>) => {
      this.table.delete(id).then(() => {
        observer.next(true);
        observer.complete();
      }, (err) => {
        observer.error(err);
      });
    });
  }

  removeBulk(data: Pmc[]): Observable<boolean> {
    return new Observable((observer: Observer<boolean>) => {
      if (data && data.length > 0) {
        const pmIds: number[] = [];
        data.forEach(pmc => pmIds.push(pmc.rowid));
        this.table.bulkDelete(pmIds).then(() => {
          observer.next(true);
          observer.complete();
        }, (err) => {
          observer.error(err);
        });
      } else {
        observer.next(true);
        observer.complete();
      }
    });
  }

  update(id: number, data: Pmc): Observable<boolean> {
    return new Observable((observer: Observer<boolean>) => {
      this.table.update(id, data).then(() => {
        observer.next(true);
        observer.complete();
      }, (err) => {
        observer.error(err);
      });
    });
  }

  updateBulk(data: Pmc[]): Observable<boolean> {
    return new Observable((observer: Observer<boolean>) => {
      if (data && data.length > 0) {
        this.table.bulkPut(data).then(() => {
          observer.next(true);
          observer.complete();
        }, (err) => {
          observer.error(err);
        });
      } else {
        observer.next(true);
        observer.complete();
      }
    });
  }
}
